// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"438":"restricted-words-next","540":"restricted-words","686":"emoji-picker","819":"monetization-table"}[chunkId] || chunkId) + ".js";
};